/**
 * 推广舱 · 过渡软链(1012 老板拍板):推广舱暂时只做一件事 —— 点卡直接免密进 GEO 管理系统。
 *
 * ★后端 catalog 里 ai_promotion 仍是 coming_soon(不卖、不进套餐门);卡的「已开」与这一页都是前端软链,
 *   能不能进只看 GEO 那条线自己的判据(平台端租户详情填了 GEO 账号手机号 + secret 已配),
 *   与获客舱「外部工具 → GEO管理系统」卡同一个后端口、同一个同源反代前缀。
 * ★推广舱真做出来那天:catalog 转 active、这里换成正式舱页,useClusterCards / 侧栏的软链分支一并删。
 * ★1020 老板:没合作(没绑 GEO 账号 / 平台没配)的租户不再只给一行提示,直接内嵌 GEO 服务介绍页
 *   (bridge/enter 不带 token = 介绍页),同样走同源反代;只有接口出错仍给「稍后重试」。
 */
import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";

import {
  GEO_ENTRY_REASON_TEXT,
  geoEntryService,
  type GeoEntryReason,
} from "../api/geoEntryService";
import { EntryNotice, toProxyUrl } from "./ExternalToolsPage";

const GEO_SITE = "https://geo.xbgeo.cn/";
/** 没合作时内嵌的 GEO 服务介绍页(老板 1020 给的地址)。 */
const GEO_INTRO_URL = "https://geo.xbgeo.cn/?r=bridge/enter&embed=1";

export default function PromotionGeoPage() {
  const [entryUrl, setEntryUrl] = useState<string | null>(null);
  const [reason, setReason] = useState<GeoEntryReason | null>(null);
  const [intro, setIntro] = useState(false);

  useEffect(() => {
    let alive = true;
    geoEntryService
      .entry()
      .then((r) => {
        if (!alive) return;
        if (r.available && r.url) setEntryUrl(toProxyUrl(r.url));
        else if (r.reason === "ERROR") setReason("ERROR");
        else {
          setIntro(true);
          setEntryUrl(toProxyUrl(GEO_INTRO_URL));
        }
      })
      .catch(() => {
        if (alive) setReason("ERROR");
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="flex h-[calc(100vh-10rem)] min-h-[480px] flex-col">
      <div className="mb-3 flex flex-wrap items-center gap-3">
        <span className="font-semibold">
          {intro ? "推广舱 · GEO 优化服务" : "推广舱 · GEO 管理系统"}
        </span>
        <a
          href={intro ? GEO_INTRO_URL : GEO_SITE}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-primary"
        >
          <ExternalLink className="h-4 w-4" />
          新窗口打开
        </a>
      </div>
      {reason ? (
        <EntryNotice text={GEO_ENTRY_REASON_TEXT[reason]} />
      ) : !entryUrl ? (
        <div className="grid flex-1 place-items-center rounded-lg border bg-background text-sm text-muted-foreground">
          正在进入…
        </div>
      ) : (
        <iframe
          src={entryUrl}
          title={intro ? "GEO 优化服务介绍" : "GEO 管理系统"}
          className="w-full flex-1 rounded-lg border bg-background"
        />
      )}
    </div>
  );
}
